/**
 * Which playoff bonus columns to show for the playoff standings `scoring` summary.
 * Responses without a summary show both (the original round robin bonus rules).
 */
export const getPlayoffBonusColumns = (scoring) => ({
  goalBonus: scoring?.hasGoalBonus ?? true,
  shutout: scoring?.hasShutoutBonus ?? true,
});
